/*
 * hw-cart-upsell.js — one-tap "Add" for the cart-drawer upsell card.
 * Loaded once with the cart drawer; uses event delegation so it keeps working
 * after Dawn re-renders the drawer contents.
 */
(function () {
  function addUrl() {
    if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url;
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + 'cart/add';
    }
    return '/cart/add';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-hw-upsell-add]') : null;
    if (!btn) return;
    e.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled) return;

    var label = btn.querySelector('[data-hw-upsell-label]');
    var originalText = label ? label.textContent : '';
    btn.disabled = true;
    if (label) label.textContent = 'Adding…';

    // On the full cart page (button not inside the drawer) we reload so the new
    // line + updated totals show in place. Inside the drawer we re-render it.
    var inDrawer = btn.closest('#CartDrawer');
    var drawer = inDrawer ? document.querySelector('cart-drawer') : null;
    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);
    if (drawer) {
      body.append('sections', 'cart-drawer,cart-icon-bubble');
      body.append('sections_url', window.location.pathname);
    }

    fetch(addUrl() + '.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data && data.status) {
          // add failed (e.g. sold out) — restore the button
          btn.disabled = false;
          if (label) label.textContent = originalText;
          return;
        }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.disabled = false;
        if (label) label.textContent = originalText;
      });
  });
})();
